import {mapGetters} from "vuex";

export const discountMixin = {
  computed: {
    ...mapGetters(['discount'])
  },
  methods: {
    calculateDiscount(price) {
      let discountPrice = price;

      if (this.discount.type === "relative") {
        discountPrice = Math.round(price - ((price / 100) * this.discount.value));
      } else if (this.discount.type === "absolute") {
        discountPrice = price - this.discount.value;
      }

      // console.log('new discount price: ', discountPrice, price);

      if (discountPrice >= this.discount.minValue) {
        return discountPrice;
      }
      return false;
    }
  }
};
